export const radioCardGroupStandard = {
  name: 'foo',
  label: 'Is this the one?',
  defaultOption: {
    value: 'two',
    label: 'Two',
  },
  options: [
    {
      value: 'one',
      children: 'One',
      label: 'One',
    },
    {
      value: 'two',
      children: 'Two',
      label: 'Two',
    },
    {
      value: 'three',
      children: 'Three',
      label: 'Three',
    },
  ],
};

export const radioCardGroupShowLabel = {
  ...radioCardGroupStandard,
  showLabel: true,
  tooltip: {
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: 'heading-1',
        data: {},
        content: [
          {
            nodeType: 'text',
            value: "Don't see the role you're looking for?",
            marks: [],
            data: {},
          },
        ],
      },
      {
        nodeType: 'paragraph',
        data: {},
        content: [{ nodeType: 'text', value: 'Lorem ipsu', marks: [], data: {} }],
      },
    ],
  },
};
